import { withMutationNotifications } from 'app/shared/api/rtk-mutation-notifications';
import { configManagerCloudServicesApi as api } from '../configManagerCloudServicesApi';
import {
  SubscribeAccountToProductConfigManagerCloudServicesApiV1SubscriptionsPostApiResponse,
  SubscribeAccountToProductConfigManagerCloudServicesApiV1SubscriptionsPostApiArg,
  ListAccountSubscriptionsConfigManagerCloudServicesApiV1SubscriptionsCurrentGetApiResponse,
  ListAccountSubscriptionsConfigManagerCloudServicesApiV1SubscriptionsCurrentGetApiArg,
  DeleteSubscriptionApiResponse,
  DeleteSubscriptionApiArg,
} from './types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    subscribeAccountToProductConfigManagerCloudServicesApiV1SubscriptionsPost: build.mutation<
      SubscribeAccountToProductConfigManagerCloudServicesApiV1SubscriptionsPostApiResponse,
      SubscribeAccountToProductConfigManagerCloudServicesApiV1SubscriptionsPostApiArg
    >({
      query: queryArg => ({
        url: `/config-manager-cloud-services/api/v1/subscriptions/`,
        method: 'POST',
        body: queryArg.subscriptionCreate,
      }),
      invalidatesTags: ['SUBSCRIPTIONS'],
      onQueryStarted: withMutationNotifications({
        success: () => 'Subscribed to product successfully',
        error: () => 'Async error! : failed to subscribe to product',
      }),
    }),
    listAccountSubscriptionsConfigManagerCloudServicesApiV1SubscriptionsCurrentGet: build.query<
      ListAccountSubscriptionsConfigManagerCloudServicesApiV1SubscriptionsCurrentGetApiResponse,
      ListAccountSubscriptionsConfigManagerCloudServicesApiV1SubscriptionsCurrentGetApiArg
    >({
      query: () => ({ url: `/config-manager-cloud-services/api/v1/subscriptions/current` }),
      providesTags: ['SUBSCRIPTIONS'],
    }),
    deleteSubscription: build.mutation<DeleteSubscriptionApiResponse, DeleteSubscriptionApiArg>({
      query: queryArg => ({
        url: `/config-manager-cloud-services/api/v1/subscriptions/${queryArg.subscriptionId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['SUBSCRIPTIONS'],
      onQueryStarted: withMutationNotifications({
        success: () => 'Subscription deleted successfully',
        error: () => 'Async error! : failed to delete subscription',
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as billingApi };

export const {
  useListAccountSubscriptionsConfigManagerCloudServicesApiV1SubscriptionsCurrentGetQuery,
  useSubscribeAccountToProductConfigManagerCloudServicesApiV1SubscriptionsPostMutation,
  useDeleteSubscriptionMutation,
} = injectedRtkApi;
